import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

// Master account credentials used to enter the real site. These are kept in
// code (never shown on screen) so a single Enter button logs straight in.
const MASTER_USERNAME = 'Riddler';
const MASTER_PASSWORD = '190838';

export function LoginPage() {
  const { login, error, clearError, isLoading, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  // Redirect to dashboard when authenticated
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleEnter = async () => {
    clearError();
    try {
      await login(MASTER_USERNAME, MASTER_PASSWORD);
    } catch {
      // Error is handled in store
    }
  };

  return (
    <div className="min-h-screen bg-surface-950 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 bg-brand-600 rounded-2xl flex items-center justify-center mb-4 glow-brand">
            <Shield className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-surface-100">Mr Ai Coin</h1>
          <p className="text-sm text-surface-500 mt-1">AI-Powered Cryptocurrency Trading Platform</p>
        </div>

        {/* Enter Card */}
        <div className="card">
          <h2 className="text-lg font-semibold text-surface-100 text-center mb-6">
            Welcome
          </h2>

          {error && (
            <div className="mb-4 p-3 rounded-lg bg-loss/10 border border-loss/20 text-loss text-sm">
              {error}
            </div>
          )}

          <button
            type="button"
            onClick={handleEnter}
            disabled={isLoading}
            className="btn-primary w-full py-3 text-base"
          >
            {isLoading ? (
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mx-auto" />
            ) : (
              'Enter'
            )}
          </button>
        </div>

        <p className="text-center text-xs text-surface-600 mt-6">
          Paper trading mode by default • Live trading requires activation
        </p>
      </div>
    </div>
  );
}
